import cloneDeep from 'lodash/cloneDeep';
import { DATASET } from '@utils/constants';
import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';
import { findDimensionDetailsInFilter } from '@src/utils/filter/getDimensionTypesFromFilter';
import {
  getInvertedPercentageMetricByKey,
  getPercentageMetricByKey,
} from '@src/utils/metrics/metricHelpers';

const query = {
  type: 'group-by',
  dataset: DATASET,
  metrics: [], // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 25,
  groupBy: [
    '', // dimension name
  ],
  orderBy: 'desc',
  sortBy: [{ metric: 'Plays', order: 'desc' }],
  options: {
    withTotals: true,
  },
};

export const buildDimensionQuery = ({
  dimension,
  metrics,
  filter,
  interval,
  sortByMetric,
  doNotSort,
}) => {
  // unit toggle metrics
  const invertedMetrics: any = [];
  metrics.forEach((m) => {
    const percentageMetric = getPercentageMetricByKey({ metricKey: m });
    if (percentageMetric) {
      invertedMetrics.push(percentageMetric);
    }
  });

  const context = window.conviva.context;

  const q = {
    ...cloneDeep(query),
    interval,
    filter,
    metrics: [...metrics, ...invertedMetrics],
    groupBy: Array.isArray(dimension) ? dimension : [dimension],
    context: context,
  };

  if (sortByMetric && !doNotSort) {
    q.sortBy[0].metric = sortByMetric;
  } else {
    q.sortBy = [];
  }
  return q;
};

export const showNAForDimensionMetric = (
  filter,
  dimensionsByTypes,
  dimensionMetricsToNA,
  dimension,
) => {
  const { dimensionTypes } = findDimensionDetailsInFilter(filter.rule, dimensionsByTypes);
  const hasAiDimensionFilter = dimensionTypes.find((tag) => tag === DIMENSION_TYPES_CONSTANTS.ai);
  const isMetricInDimensionMetricsToNa = (metric) =>
    dimensionMetricsToNA.includes(metric) ||
    dimensionMetricsToNA.includes(getInvertedPercentageMetricByKey({ metricKey: metric }));

  const showNAForMetric = (metric) =>
    filter.rule.length && hasAiDimensionFilter
      ? isMetricInDimensionMetricsToNa(metric)
      : dimensionsByTypes?.[dimension] === DIMENSION_TYPES_CONSTANTS.ai &&
        isMetricInDimensionMetricsToNa(metric);

  return dimensionMetricsToNA && dimensionMetricsToNA.length ? showNAForMetric : null;
};
